export const PRODUCT_CATEGORIES_REDUCER_NAME = 'product-categories';

export const productCategoriesReducer = (state = {}) => state;

export const getProductCategories = (state) => state[PRODUCT_CATEGORIES_REDUCER_NAME];
